// Master SKU Tag API
// ใช้สำหรับเรียก /master/sku-tags — Global tag/badge ของ SKU (เช่น sale_channel: wholesale/retail)

import { AxiosResponse } from "axios";
import httpClient from "../axios/interceptors";
import { handleResponseError } from "helpers/utils";
import { API } from "./endpoint";

export interface MasterSkuTagItem {
  id: string;
  key: string;
  name: string;
  description?: string | null;
  bg_color?: string | null;
  text_color?: string | null;
  bg_color_flutter?: string | null;
  text_color_flutter?: string | null;
  metadata?: Record<string, unknown> | null;
  tag_type?: string | null;
  exclusive_group?: string | null;
  sequence?: number;
  is_active?: boolean;
  create_date?: string;
  update_date?: string;
}

export interface GetAllMasterSkuTagsRequest {
  page_number?: number;
  row_per_page?: number;
  search?: string;
  tag_type?: string;
  exclusive_group?: string;
  is_active?: boolean;
}

export interface GetAllMasterSkuTagsResponse {
  status: number;
  developerMessage: string;
  userMessage: string;
  moreInfo: string;
  data: {
    master_sku_tags: MasterSkuTagItem[];
    total_record: number;
    has_more: boolean;
  };
}

export const getAllMasterSkuTags = async (
  input: GetAllMasterSkuTagsRequest
): Promise<GetAllMasterSkuTagsResponse> => {
  const data: AxiosResponse<GetAllMasterSkuTagsResponse> = await httpClient
    .post(API.masterSkuTagGetAll, input)
    .catch((error) => handleResponseError(error));
  return data.data;
};
